var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{staticClass:"a-hero-title"},[_c('h1',[_vm._v(_vm._s(_vm.$options.text))]),_c('h2',[_vm._v(_vm._s(_vm.$options.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }